import './PaymentMethodDetails.pcss';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { selectAccountDetails } from '@mm/state/selectors/subscriptionSelectors';
import { Button } from '@mm/components';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';

type Props = { className?: string };

const PaymentMethodDetails = ({ className }: Props) => {
  const accountDetails = useSelector(selectAccountDetails);
  const company = useSelector(activeCompanySelector);
  const account = accountDetails ? accountDetails.account : undefined;
  const editBillingLink =
    account && account.editBillingLink ? account.editBillingLink : '';
  const [showWarning, setShowWarning] = useState(
    company?.requiresAddressVerification,
  );

  if (account) {
    return (
      <div className={classnames('payment-method-details', className)}>
        <div className="payment-method-details__billing">
          <div className="payment-method-details__billed-with-text">
            Billed With:{' '}
          </div>

          <div className="payment-method-details__card-details">
            XXXX XXXX XXXX {account.lastCardNumbers}
          </div>
          {!showWarning && (
            <a
              href={editBillingLink}
              target="_blank"
              rel="noopener noreferrer"
              className="payment-method-details__edit-billing-info"
            >
              Edit Billing Info
            </a>
          )}
        </div>
        {showWarning && (
          <div className="payment-method-details__alert">
            <div>
              <ExclamationCircleFilled className="payment-method-details__alert-icon" />
              Please add your billing address
            </div>
            <Button
              color="secondary-blue"
              css={{ container: 'payment-method-details__alert-button' }}
              onClick={() => {
                setShowWarning(false);
                window.open(editBillingLink, '_blanck');
              }}
            >
              Add Billing Address
            </Button>
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default PaymentMethodDetails;
